export default {
  "home.heading.default": "šok į skambutį",
  "home.heading.loading": "Atidaromas kambarys...",
  "home.heading.join": "pasiruošęs prisijungti?",
  "home.heading.joined": "tu viduje",
  "home.heading.pending": "laukiama hosto",
  "home.body.default": "sukurk kambarį, numesk nuorodą, vibe'ink.",
  "home.body.loading": "sekundę, ruošiame kambarį.",
  "home.body.join": "pasitikrink kamerą ir mikrą, tada šok vidun.",
  "home.body.joined": "kambarys paruoštas. dalinkis nuoroda arba tiesiog varyk.",
  "home.body.joined_in_room": "kambaryje — šok vidun arba dalinkis nuoroda.",
  "home.body.pending": "kambarys užrakintas. hostas tave įleis.",
  "home.cta.create": "Sukurti kambarį",
  "home.cta.join": "Prisijungti",
  "home.cta.enter": "Užeiti",
  "home.cta.creating": "Kuriama...",
  "home.cta.joining": "Jungiamasi...",
  "home.cta.opening": "Atidaroma...",
  "home.cta.pending": "Laukiama patvirtinimo...",
  "home.copy_link": "kopijuoti nuorodą",
  "home.copied": "nukopijuota!",
  "home.leave": "išeiti iš kambario",
  "home.back": "atgal",
  "home.no_participants": "kol kas nieko nėra",
  "home.join_by_code": "prisijungti su kodu",
  "home.code_placeholder": "įvesk kodą",
  "home.name_placeholder": "tavo vardas",
  "home.people_one": "žmogus",
  "home.people_other": "žmonės",
  "home.marketing.invite.title": "Sukurk kambarį,\ndalinkis nuoroda.",
  "home.marketing.invite.body": "Vienas paspaudimas ir pradedam. Numesk nuorodą draugams ir bet kas galės prisijungti — jokių siuntimųsi ar registracijų.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Atrodyk taip,\nkaip nori.",
  "home.marketing.look.body": "Spalvų korekcija, švelninimas, vinjetė — arba visiškai užbluruok veidą. Tavo kamera, tavo stilius.",
  "home.marketing.host.title": "Tavo erdvė,\ntavo taisyklės.",
  "home.marketing.host.body": "Užrakink kambarį, užmutink ką nors arba išmesk visai. Hostas valdo situaciją.",
  "home.marketing.host.locked": "Kambarys užrakintas",
  "home.marketing.host.waiting_to_join": "Laukia prisijungimo",
  "home.marketing.host.wants_to_join": "nori prisijungti",
  "home.marketing.anything.title": "Tiesą sakant, bet kam.",
  "home.marketing.anything.body": "Mokslams, žaidimų vakarams, darbo standup'ams, filmų žiūrėjimui kartu — ar tiesiog chill'ui.",
  "home.marketing.use_case.study_group": "📚 mokslai",
  "home.marketing.use_case.game_night": "🎮 žaidimų vakaras",
  "home.marketing.use_case.standup": "💼 standup'as",
  "home.marketing.use_case.watch_party": "🍿 filmų vakaras",
  "home.marketing.use_case.catch_up": "☕ pokalbis",
  "home.marketing.use_case.jam_session": "🎸 jam session",
  "home.marketing.use_case.book_club": "📖 knygų klubas",
  "home.marketing.use_case.coworking": "💻 darbas kartu",
  "ended.heading": "skambutis baigėsi",
  "ended.left": "išėjai iš kambario.",
  "ended.room_ended": "{title} tau baigėsi.",
  "ended.rejoin": "grįžti",
  "ended.rejoining": "grįžtama...",
  "ended.home": "į pradžią",
  "call.connecting": "jungiamasi",
  "call.waiting": "laukiama kitų",
  "call.invite_code": "pakvietimo kodas",
  "call.audio_on": "garsas įjungtas",
  "call.muted": "užmutinta",
  "call.listening": "Klauso",
  "call.audio_muted": "Garsas išjungtas",
  "call.speaking": "kalba",
  "call.you": "tu",
  "call.you_label": "Tu",
  "call.you_suffix": "(tu)",
  "call.chat_placeholder": "rašyk žinutę...",
  "call.guest": "svečias",
  "call.room_fallback": "kambarys",
  "call.focus_view": "Fokuso vaizdas",
  "call.grid_view": "Tinklelio vaizdas",
  "call.swap_main_video": "Sukeisti pagrindinį video",
  "call.open_chat": "Atidaryti chat'ą",
  "call.close_chat": "Uždaryti chat'ą",
  "call.leave_room": "Išeiti iš kambario",
  "call.confirm_leave": "Išeiti?",
  "call.mic_on": "Mikras įjungtas",
  "call.muted_label": "Užmutinta",
  "call.camera_off": "Kamera išjungta",
  "call.connect_failed": "Nepavyko prisijungti — patikrink netą ir bandyk dar kartą.",
  "call.camera_access_failed": "Nepavyko pasiekti kameros. Patikrink naršyklės leidimus ir bandyk vėl.",
  "call.recording_failed": "Nepavyko pradėti įrašymo. Skambutis tęsis be jo.",
  "call.initialize_failed": "Kažkas lūžo pradedant skambutį. Perkauk puslapį ir bandyk dar kartą.",
  "call.participants": "Dalyviai",
  "call.open_participants": "Atidaryti dalyvius",
  "call.close_participants": "Uždaryti dalyvius",
  "call.lock_room": "Užrakinti kambarį",
  "call.unlock_room": "Atrakinti kambarį",
  "call.locked": "užrakinta",
  "call.unlocked": "atidaryta",
  "call.kick_member": "Išmesti iš kambario",
  "call.mute_member": "Užmutinti",
  "call.unmute_member": "Atmutinti",
  "call.muted_by_host": "Užmutino hostas",
  "call.waiting_to_join": "Laukia prisijungimo",
  "call.approve": "Patvirtinti",
  "call.deny": "Atmesti",
  "call.profile_actions": "Profilio veiksmai",
  "call.profile_in_room": "Kambaryje",
  "call.profile_role_host": "Hostas",
  "call.profile_role_you": "Tu",
  "call.profile_action_mute": "Užmutinti jų garsą",
  "call.profile_action_mute_meta": "Tik tau — jie nesužinos",
  "call.profile_action_dm": "1:1 DM",
  "call.profile_action_dm_meta": "Pradėk privatų pokalbį",
  "call.profile_action_view": "Žiūrėti visą profilį",
  "call.profile_action_view_meta": "Bio, kalbos, praeiti skambučiai",
  "call.profile_action_report": "Reportinti",
  "call.profile_action_report_meta": "Pažymėti moderatorių peržiūrai",
  "call.profile_sheet_close": "Uždaryti profilio veiksmus",
  "call.profile_open_actions": "Atidaryti profilio veiksmus",
  "call.dm_title": "Privati žinutė",
  "call.dm_back": "Atgal į veiksmus",
  "call.dm_close": "Uždaryti privačią žinutę",
  "call.dm_status_online": "Prisijungęs",
  "call.dm_in_room_with": "Šiame kambaryje",
  "call.dm_private_label": "Privatus chat'as",
  "call.dm_private_meta": "Šias žinutes matote tik jūs dviese",
  "call.dm_input_placeholder": "Rašyk privačią žinutę…",
  "call.dm_send": "Siųsti",
  "call.dm_just_now": "dabar",
  "call.dm_seen_just_now": "Ką tik matyta",
  "call.dm_typing": "{name} rašo…",
  "call.dm_minimize": "Sumažinti",
  "call.dm_active_indicator": "Atidaryti pokalbį",
  "call.dm_unread_messages": "{count} neskaityta",
  "call.dm_toast_tap_to_open": "Spausk, kad atidarytum",
  "call.dm_reopen_aria": "Vėl atidaryti pokalbį su {name}",
  "home.join_denied": "Hostas tavęs neįleido.",
  "home.error.room_not_found": "Tokio kambario kodo nėra.",
  "home.error.profile_required": "Susikurk profilį, kad galėtum tęsti.",
  "home.cta.set_up_profile": "Susikurti profilį",
  "home.profile_trigger_new": "Spausk ir pridėk info apie save",
  "home.profile_trigger_new_aria": "Susikurti profilį",
  "home.profile_trigger_edit_aria": "Redaguoti profilį",
  "profile.eyebrow_new": "pasisveikink",
  "profile.eyebrow_edit": "tavo profilis",
  "profile.title_new": "Padaryk jį savo.",
  "profile.title_edit": "Redaguoti profilį",
  "profile.subtitle": "Keli greiti faktai, kad kiti žinotų, su kuo bendrauja.",
  "profile.add_photo": "Pridėti nuotrauką",
  "profile.add_photo_soon": "nuotraukos greitai bus",
  "profile.photo_empty": "spausk ir pridėk nuotrauką",
  "profile.photo_ready": "nuotrauka paruošta",
  "profile.photo_save_first": "prieš keliant nuotrauką, išsaugok profilį",
  "profile.photo_crop_caption": "įrėmink nuotrauką",
  "profile.photo_auto_caption": "tempk ir priartink, o mes išsaugosim automatiškai",
  "profile.photo_upload": "Įkelti nuotrauką",
  "profile.photo_replace": "Pakeisti nuotrauką",
  "profile.photo_remove": "Pašalinti nuotrauką",
  "profile.photo_cancel": "Atšaukti",
  "profile.photo_save": "Išsaugoti nuotrauką",
  "profile.photo_uploading": "Keliama nuotrauka…",
  "profile.photo_removing": "Šalinama nuotrauka…",
  "profile.photo_choose_another": "Pasirinkti kitą",
  "profile.photo_drag_hint": "Tempk nuotrauką į apskritimo vidų. Pakeitimai išsisaugos automatiškai.",
  "profile.photo_zoom": "Priartinti",
  "profile.photo_horizontal": "Horizontalus kirpimas",
  "profile.photo_vertical": "Vertikalus kirpimas",
  "profile.name_label": "Vardas",
  "profile.name_placeholder": "Kaip tave vadinti?",
  "profile.gender_label": "Aš esu",
  "profile.gender.woman": "Moteris",
  "profile.gender.man": "Vyras",
  "profile.gender.unspecified": "Nenoriu sakyti",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "neprivaloma",
  "profile.bio_placeholder": "Kalbos, kurias moki, kas patinka, bet kas…",
  "profile.cta_new": "Varom",
  "profile.cta_edit": "Išsaugoti",
  "profile.saving": "Saugoma…",
  "profile.close": "Uždaryti",
  "profile.error.save_failed": "Nepavyko išsaugoti profilio. Bandyk dar kartą.",
  "profile.error.avatar_invalid_type": "Rinkis PNG, JPEG, GIF arba WebP nuotrauką.",
  "profile.error.avatar_too_large": "Nuotrauka turi būti mažesnė nei 5 MB.",
  "profile.error.avatar_too_small": "Nuotrauka turi būti bent 96x96 pikselių.",
  "profile.error.avatar_load_failed": "Nepavyko nuskaityti nuotraukos. Bandyk kitą failą.",
  "profile.error.avatar_failed": "Nepavyko įkelti nuotraukos. Bandyk dar kartą.",
  "profile.error.avatar_remove_failed": "Nepavyko pašalinti nuotraukos. Bandyk dar kartą.",
  "effects.title": "Efektai",
  "effects.soft": "Švelnus fokusas",
  "effects.vignette": "Vinjetė",
  "effects.face": "Veido blur'as",
  "effects.face_preview_only": "Veido blur'as (tik peržiūra)",
  "effects.face_viewer_side": "Veido blur'as (žiūrovo pusėje)",
  "effects.face_strength": "Veido blur'o stiprumas",
  "effects.grade.off": "IŠJUNGTA",
  "effects.grade.pop": "RYŠKU",
  "effects.grade.warm": "ŠILTA",
  "effects.grade.cool": "ŠALTA",
  "effects.grade.bw": "J/B",
  "camera.off": "kamera išjungta",
  "camera.check": "pasitikrink kamerą",
  "camera.retry": "bandyti kamerą dar kartą",
  "camera.ready": "kamera paruošta",
  "camera.idle.title": "Įsijunk kamerą",
  "camera.idle.hint": "Paprašysim naršyklės leidimo, kai būsi pasiruošęs.",
  "camera.idle.button": "Įjungti kamerą",
  "camera.status.idle": "Laukiame tavęs",
  "camera.status.off": "Kamera išjungta",
  "camera.status.loading": "Prašoma prieigos prie kameros...",
  "camera.status.denied": "Leisk naudoti kamerą naršyklėje ir bandyk dar kartą.",
  "camera.status.error": "Nepavyko užkrauti kameros vaizdo. Bandyk dar kartą.",
  "camera.status.unsupported": "Ši naršyklė neleidžia naudoti kameros.",
  "camera.status.insecure": "Kamerai reikia HTTPS arba localhost.",
  "camera.status.attach_failed": "Nepavyko paleisti kameros vaizdo. Bandyk dar kartą.",
  "camera.guest_name_placeholder": "Svečio vardas",
  "camera.flip": "Apversti kamerą",
  "camera.save_name": "Išsaugoti",
  "camera.edit_name": "Keisti vardą",
  "mic.on": "Išjungti mikrą",
  "mic.off": "Įjungti mikrą",
  "video.on": "Išjungti kamerą",
  "video.off": "Įjungti kamerą",
  "chat.title": "chat'as",
  "chat.close": "Uždaryti chat'ą",
  "chat.loading": "kraunama...",
  "chat.load_earlier": "užkrauti senesnes",
  "chat.empty": "kol kas žinučių nėra",
  "chat.send_error": "Žinutė neišsisiuntė — bandyk dar kartą.",
  "chat.input_placeholder": "rašyk žinutę...",
  "room.host": "Hostas",
  "app.room_default_title": "Sukurti kambarį",
  "app.chat_connection_rejected": "Nepavyko prisijungti prie chat'o — pabandyk perkrauti.",
  "app.copy_failed": "Nepavyko nukopijuoti nuorodos. Pabandyk pažymėti ir nukopijuoti ranka.",
  "app.chat_not_connected": "Chat'as dar neprisijungė. Palauk sekundę ir bandyk vėl.",
  "footer.terms": "Taisyklės ir sąlygos",
  "footer.copyright": "© 2026 Yano.AI"
}
